var TEMPLATE_URL = require('./premium.expired.tile.html');

angular.module('ikeweb.user').directive('premiumExpiredTile', [

    function() {
        return {
            replace: true,
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            scope: {
                currentCard: '=',
                subscription: '=',
                openPurchasePremiumModal: '&',
                openPurchaseTrialModal: '&',
                canTrial: '=',
                openUpdateCard: '&'

            },
            link: function($scope, $element, attrs) {
                var ccView = $element.find('.Subscription-creditCardView');
                $scope.toggleCreditCardView = function() {

                    ccView.toggleClass('Subscription-creditCardView--closed')
                        .toggleClass('Subscription-creditCardView--open');
                };
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/premium.expired.tile.directive.js
// module id = 499
// module chunks = 0